import { useEffect, useRef } from 'react'
import '@/style/common/pageHero.scss'

/**
 * 内页通用头图。
 * 左侧为文字信息，右侧为带工业质感处理的图片，底部接内容区。
 */
function PageHero({ eyebrow, title, desc, image, alt = '', stat }) {
  const ref = useRef(null)

  useEffect(() => {
    const node = ref.current
    if (!node) return
    const onScroll = () => {
      const offset = Math.min(window.scrollY, 600)
      node.style.setProperty('--hero-shift', `${offset * 0.22}px`)
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header className="pageHero" ref={ref}>
      <div className="pageHero__bg" style={{ backgroundImage: `url(${image})` }} aria-hidden="true" />
      <div className="pageHero__scrim" aria-hidden="true" />
      <div className="pageHero__grid" aria-hidden="true" />

      <div className="mainContent pageHero__inner">
        <div className="pageHero__text">
          {eyebrow && <p className="pageHero__eyebrow">{eyebrow}</p>}
          <h1 className="pageHero__title">{title}</h1>
          {desc && <p className="pageHero__desc">{desc}</p>}
        </div>

        {stat && (
          <ul className="pageHero__stats">
            {stat.map((s) => (
              <li key={s.label}>
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </li>
            ))}
          </ul>
        )}
      </div>

      {alt && <span className="sr-only">{alt}</span>}
    </header>
  )
}

export default PageHero